import type { InjectionKey } from 'vue';

import type { MapState } from './mapState';
import type { RecipeState } from './recipeState';
import type { TripState } from './tripState';
import type { CriteriaState } from './criteriaState';
import type { ProductDetailState } from './productDetailState';

export const RecipeStateSymbol = Symbol('recipe-state');
export const TripStateSymbol = Symbol('trip-state');
export const ProductDetailStateSymbol = Symbol('product-detail');
export const CriteriaStateSymbol = Symbol('criteria-state');
export const MapStateSymbol = Symbol('map-state');

export const RecipeStateKey: InjectionKey<RecipeState> = RecipeStateSymbol;
export const TripStateKey: InjectionKey<TripState> = TripStateSymbol;
export const CriteriaStateKey: InjectionKey<CriteriaState> =
  CriteriaStateSymbol;
export const ProductDetailStateKey: InjectionKey<ProductDetailState> =
  ProductDetailStateSymbol;
export const MapStateKey: InjectionKey<MapState> = MapStateSymbol;
